import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { Box } from "@mui/material";
import CloseIcon from "@assets/icons/new/close_24px.svg?react";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { useState } from "react";
import { CreditCheckoutPage } from "@pages/settings/subscription-settings/credits/credit-checkout-page";
import { HeaderLayoutLeftButton } from "@components/page-layout/header/header-layout-left-button";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { selectedSdbCompanyIdSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { SettingsTabs } from "@router/route-params";
import { isAlphaTestingEnabledSelector } from "@store/app/app-selector";
import { ForbiddenPage } from "@pages/forbidden-page";
import { RuntimeUtils } from "@stellar/web-core";
import { runtimeConfig } from "@src/runtime-config";
import { CreditPackages } from "@pages/settings/subscription-settings/credits/credit-packages";
import { SphereDashboardAPITypes } from "@stellar/api-logic";

/** Renders a page with list of credit packages available for purchase */
export function AddCreditsPage(): JSX.Element {
  const { navigateToSettingsPage } = useAppNavigation();
  const companyId = useAppSelector(selectedSdbCompanyIdSelector);
  const isAlphaTestingEnabled = useAppSelector(isAlphaTestingEnabledSelector);
  const isProduction = RuntimeUtils.isProductionEnvironment(
    runtimeConfig.appEnv
  );

  const [selectedPackage, setSelectedPackage] = useState<
    SphereDashboardAPITypes.StripeProduct | undefined
  >(undefined);
  const [shouldCheckout, setShouldCheckout] = useState<boolean>(false);

  if (!isAlphaTestingEnabled || isProduction) {
    return <ForbiddenPage />;
  }

  if (shouldCheckout && selectedPackage) {
    return (
      <CreditCheckoutPage
        creditPackage={selectedPackage}
        setShouldCheckout={setShouldCheckout}
      />
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <MainPageLayout
        shouldHideOpenButton={true}
        shouldShowSidebar={false}
        shouldShowTopbarBorder={true}
        topLeftHeaderButton={
          <HeaderLayoutLeftButton
            tooltip={`Close ${CREDITS_DISPLAY_NAME} page`}
            icon={CloseIcon}
            text="Close"
            onClickHandler={() =>
              navigateToSettingsPage({
                companyId: companyId ?? "",
                settingsTab: SettingsTabs.subscription,
              })
            }
          />
        }
        shouldUseFullBodyLayout={true}
      >
        <CreditPackages
          selectedPackage={selectedPackage}
          setSelectedPackage={setSelectedPackage}
          setShouldCheckout={setShouldCheckout}
        />
      </MainPageLayout>
    </Box>
  );
}
